import React, { useEffect, useState } from "react";
import {
  Form,
  Select,
  Button,
  Row,
  Col,
  Steps,
  message,
  Slider,
  InputNumber,
  Switch,
} from "antd";
import { useSocket } from "@components/SocketProvider";
import toast from "react-hot-toast";
import FileDownload from "js-file-download";
import planningService from "@services/planning.service";
import ColorPicker from "../../../WebGIS/Legends/components/ColorPicker";
const { Step } = Steps;

/* eslint-disable no-template-curly-in-string */
const validateMessages = {
  required: "${label} is required!",
};
/* eslint-enable no-template-curly-in-string */

let interval = undefined;

const KML_Brtel = () => {
  // eslint-disable-next-line
  const socket = useSocket();

  const [submitted, setSubmitted] = useState(false);
  const [progress, setProgress] = useState(0);
  const [regions, setRegions] = useState({
    loading: false,
    data: [],
    error: null,
  });
  const [provinces, setProvinces] = useState({
    loading: false,
    data: [],
    error: null,
  });
  const [cities, setCities] = useState({
    loading: false,
    data: [],
    error: null,
  });
  const [sites, setSites] = useState({
    loading: false,
    data: [],
    error: null,
  });
  const [techs, setTechs] = useState(() => {
    // getting stored value
    const saved = localStorage.getItem("techs");
    const initialValue = JSON.parse(saved);
    return (
      initialValue || [
        { name: "GSM", size: 120, color: "#9013fe", checked: true },
        { name: "U900", size: 110, color: "#bd10e0", checked: true },
        { name: "U2100", size: 100, color: "#417505", checked: true },
        { name: "L900", size: 90, color: "#10e0ca", checked: true },
        { name: "L1800", size: 90, color: "#7ed321", checked: true },
        { name: "L2600", size: 80, color: "#8b572a", checked: true },
        { name: "L2300", size: 70, color: "#f8e71c", checked: true },
        { name: "L2100", size: 60, color: "#f5a623", checked: true },
        { name: "TDD", size: 50, color: "#d0021b", checked: true },
        { name: "5G", size: 40, color: "#2c44a7", checked: true },
      ]
    );
  });

  const [form] = Form.useForm();
  useEffect(() => {
    localStorage.setItem("techs", JSON.stringify(techs));
  }, [techs]);
  useEffect(() => {
    if (submitted) {
      interval = setInterval(() => {
        setProgress((prev) => prev + 1);
      }, 100);
    } else {
      clearInterval(interval);
    }
  }, [submitted]);

  useEffect(() => {
    if (progress === 100) {
      // setSubmitted(false);
      // clearInterval(interval);
    }
    // eslint-disable-next-line
  }, [progress]);

  async function fetchRegions() {
    setRegions({ ...regions, loading: true });

    try {
      const res = await planningService.Get("/brtel_mci/regions");

      setRegions({
        ...regions,
        loading: false,
        data: res.data.map((r) => ({ label: r, value: r })),
      });
    } catch (error) {
      console.log(error);
      setRegions({ ...regions, loading: false, error: error });
    }
  }

  async function fetchProvinces() {
    setProvinces({ ...provinces, loading: true });
    try {
      const res = await planningService.Get("/brtel_mci/provinces");
      setProvinces({
        ...provinces,
        loading: false,
        data: res.data.map((p) => ({ label: p, value: p })),
      });
    } catch (error) {
      console.log(error);
      setProvinces({ ...provinces, loading: false, error: error });
    }
  }

  async function fetchCities() {
    setCities({ ...cities, loading: true });

    try {
      const res = await planningService.Get("/brtel_mci/cities");
      setCities({
        ...cities,
        loading: false,
        data: res.data.map((c) => ({ label: c, value: c })),
      });
    } catch (error) {
      console.log(error);
      setCities({ ...cities, loading: false, error: error });
    }
  }

  async function fetchSites() {
    setSites({ ...sites, loading: true });

    try {
      const res = await planningService.Get("/brtel_mci/sites");
      setSites({
        ...sites,
        loading: false,
        data: res.data.map((s) => ({ label: s, value: s })),
      });
    } catch (error) {
      console.log(error);
      setSites({ ...sites, loading: false, error: error });
    }
  }
  // async function setTech() {
  //   setSites({ ...sites, loading: true });

  // }

  function fetchDatas() {
    fetchProvinces();
    fetchRegions();
    fetchCities();
    fetchSites();
  }
  useEffect(() => {
    socket.on("progress", function (data) {
      // console.log("progress", data);
      setProgress(data);
    });

    fetchDatas();

    socket.on("message", function (data) {
      // console.log("message", data);
      if (data.s === 0) {
        // setSubmitted(false);
        toast.error(data.message);
      }
    });
    // eslint-disable-next-line
  }, []);

  const onFinish = async (values) => {
    console.log(values);
    values["settings"] = techs;
    // values=values.concat(techs);
    // console.log(values);
    setProgress(0);
    setSubmitted(true);
    try {
      const res = await planningService.PostBlob("/brtel_mci/kml", {
        ...values,
        io_id: socket.id,
      });
      console.log("fff")
      setSubmitted(false);
      clearInterval(interval);
      setProgress(100);
      FileDownload(res.data, "kml.kmz");
      // console.log(res.data);
      // window.open(res.data, '_blank', 'noreferrer')
      // FileDownload(res.data, `kml-${new Date()}.kmz`);
    } catch (err) {
      message.error("Action has error", 20);
      console.log(err);
      setSubmitted(false);
    }
  };

  return (
    <div className="p-5 h-full img-bg img-bg-google-earth">
      <div className="bg-white border border-gray-200 rounded-md p-5 flex-grow">
        <Form
          form={form}
          layout="vertical"
          name="nest-messages"
          onFinish={onFinish}
          validateMessages={validateMessages}
        // onValuesChange={handleFormValuesChange}
        >
          <Row justify="center">
            <Col span={4}>
              <Form.Item
                name="region"
                label="Region"
                rules={[
                  {
                    type: "array",
                    // required: true,
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  allowClear
                  showSearch
                  style={{ width: "100%" }}
                  placeholder="Please select"
                  // maxTagCount={5}
                  options={regions.data}
                />
              </Form.Item>
              <Form.Item
                name="province"
                label="Province"
                rules={[
                  {
                    type: "array",
                    // required: true,
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  allowClear
                  showSearch
                  style={{ width: "100%" }}
                  placeholder="Please select"
                  // maxTagCount={5}
                  options={provinces.data}
                />
              </Form.Item>
              <Form.Item
                name="city"
                label="City"
                rules={[
                  {
                    type: "array",
                    // required: true,
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  allowClear
                  showSearch
                  style={{ width: "100%" }}
                  placeholder="Please select"
                  // maxTagCount={5}
                  options={cities.data}
                />
              </Form.Item>
              <Form.Item
                name="site"
                label="Site"
                rules={[
                  {
                    type: "array",
                    // required: true,
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  allowClear
                  showSearch
                  style={{ width: "100%" }}
                  placeholder="Please select"
                  // maxTagCount={5}
                  options={sites.data}
                />
              </Form.Item>{" "}
            </Col>
            <Col span={16}>
              {techs.map((tech) => (
                <Row justify="center" align="middle">
                  <Col span={3}>
                    <Switch
                      checked={tech.checked}
                      size="small"
                      checkedChildren={tech.name}
                      unCheckedChildren={tech.name}
                      onChange={(value) => {
                        let xx = techs.filter((p) => p.name === tech.name)[0];
                        xx.checked = value;
                        setTechs([...techs]);
                      }}
                    />
                  </Col>
                  <Col span={6}>
                    <Slider
                      tooltip={{ open: true }}
                      align="middle"
                      min={0}
                      max={500}
                      step={10}
                      onChange={(value) => {
                        let xx = techs.filter((p) => p.name === tech.name)[0];
                        xx.size = value;
                        setTechs([...techs]);
                      }}
                      value={tech.size}
                    />
                  </Col>
                  <Col span={2}>
                    <label>{tech.size} m</label>
                  </Col>
                  <Col span={5}>
                    <ColorPicker
                      value={tech.color}
                      onChange={(value) => {
                        let xx = techs.filter((p) => p.name === tech.name)[0];
                        xx.color = value;
                        setTechs([...techs]);
                      }}
                    ></ColorPicker>
                  </Col>
                </Row>
              ))}
            </Col>
            <Col span={4}>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={submitted}
                  className="mt-4"
                >
                  Download
                </Button>
                <Button
                  style={{ margin: "0 8px" }}
                  onClick={() => {
                    form.resetFields();
                  }}
                >
                  Clear
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>

        {submitted && (
          <div className="mt-10">
            <Steps
              percent={progress}
              current={
                progress < 25 ? 0 : progress < 50 ? 1 : progress < 75 ? 2 : 3
              }
              direction="horizontal"
              className="mt-5"
            >
              <Step
                title={progress < 20 ? "In Progress" : "Finished"}
                description="Waiting for server response"
              />
              <Step
                title={
                  progress < 25
                    ? "Waiting"
                    : progress < 50
                      ? "In Progress"
                      : "Finished"
                }
                description="Read from Database"
              />
              <Step
                title={
                  progress < 50
                    ? "Waiting"
                    : progress < 75
                      ? "In Progress"
                      : "Finished"
                }
                description="Create Excel file"
              />
              <Step
                title={
                  progress < 75
                    ? "Waiting"
                    : progress < 100
                      ? "In Progress"
                      : "Finished"
                }
                description="Download"
              />
            </Steps>
          </div>
        )}
      </div>
    </div>
  );
};

export default KML_Brtel